import { capitalize } from "@common/helpers/string";
import {
    StatusIndicator,
    StatusIndicatorVariant,
} from "@design-system/StatusIndicator/StatusIndicator";
import { BillStatus as BillStatusEnum } from "@common/types/bill";

const STATUS_VARIANTS: Record<BillStatusEnum, StatusIndicatorVariant> = {
    [BillStatusEnum.DRAFT]: "gray",
    [BillStatusEnum.OPEN]: "yellow",
    [BillStatusEnum.PAID]: "blue",
    [BillStatusEnum.VOID]: "purple",
};

interface BillStatusProps {
    status: BillStatusEnum;
    className?: string;
    showText?: boolean;
    label?: string;
    textClassName?: string;
}

export const BillStatus: React.FC<BillStatusProps> = ({
    status,
    className,
    showText = false,
    label,
    textClassName,
}) => (
    <StatusIndicator
        variant={STATUS_VARIANTS[status]}
        label={label ?? capitalize(status)}
        showText={showText}
        className={className}
        textClassName={textClassName}
        tooltipLabel={capitalize(status)}
        tooltipSide="top"
    />
);
